import React from "react";
import _ from "lodash";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {BcaEditIcon} from "../../../../../images/BcaIcon";
import BcaIconButton from "../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import {Grid} from "@material-ui/core";

import PrimaryButton from "../../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../../components/BaseDialog/BaseDialog";
import InputFormElement from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {isValidString} from "../../../../../utils/utils";
import {parseResponse, PortfolioHandlerResource} from "../../../../../utils/api";
import {displayErrorSnackBar} from "../../../../../components/SnackbarProvider/actions";
import {SERVER_ERROR} from "../../../../../utils/constants";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";


const VirtualDepotEditButton = (props) => {
  const {
    portfolio, dispatch, onUpdate, dataProvider=PortfolioHandlerResource, portfolioType='Fremddepot'
  } = props;

  const [formData, setFormData] = React.useState({
    name: portfolio.real_name,
    extra_fields: portfolio.extra_fields || {}
  });
  const [open, setOpen] = React.useState(false);
  const [saveInProgress, setSaveInProgress] = React.useState(false);

  const handleClose = () => setOpen(false);

  const handleError = () => dispatch(displayErrorSnackBar(SERVER_ERROR));

  const handleSave = () => {
    setSaveInProgress(true);

    dataProvider.updatePortfolio(props.match.params.customer_id, portfolio.id, formData)
    .then((response) => {
      parseResponse(response, 'portfolio', () => {
        setOpen(false);
        onUpdate && onUpdate();
      }, handleError)
    })
    .catch(handleError)
    .finally(() => setSaveInProgress(false))
  };

  return (
    <>
      <BcaIconButton
        tooltip={`${portfolioType} bearbeiten`}
        icon={<BcaEditIcon />}
        onClick={() => setOpen(true)}
      />
      <BaseDialog
        open={open}
        title={`${portfolioType} bearbeiten`}
        modalLoading={saveInProgress}
        maxWidth={'md'}
        actions={
          <Grid container justify={"flex-end"} spacing={2}>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text="Abbrechen"
                variant="outlined"
                onButtonClick={handleClose}
              />
            </Grid>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text={"Speichern"}
                onButtonClick={handleSave}
                disabled={!isValidString(formData.name)}
              />
            </Grid>
          </Grid>
        }
      >
        <Grid container spacing={2}>
          <EditExternalDepotForm
            formData={formData}
            setFormData={setFormData}
            portfolio={portfolio}
            portfolioType={portfolioType}
          />
        </Grid>
      </BaseDialog>
    </>
  )
};

export default withRouter(connect()(VirtualDepotEditButton));

export const EditExternalDepotForm = ({portfolio, formData, setFormData, portfolioType='Fremddepot'}) => {
  const handleFormDataChange = (field) => (value) => {
    const newFormData = {...formData};
    _.set(newFormData, field, value)
    setFormData(newFormData)
  };

  return (
    <>
      <Grid item sm={8} xs={12}>
        <InputFormElement
          value={formData.name}
          onChange={handleFormDataChange('name')}
          fullWidth
          required
          label="Name"
          placeholder={`Bitte geben Sie einen Namen für das ${portfolioType} ein`}
          custom_classes={newDesignInputCustomClasses}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <CalendarFormElement
          required
          label="Startdatum"
          value={portfolio.tracking_start_date}
          disabled
          custom_classes={newDesignInputCustomClasses}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <InputFormElement
          value={_.get(formData, 'extra_fields.depot_number')}
          onChange={handleFormDataChange('extra_fields.depot_number')}
          fullWidth
          label="Depotnummer"
          custom_classes={newDesignInputCustomClasses}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <InputFormElement
          value={_.get(formData, 'extra_fields.custodian')}
          onChange={handleFormDataChange('extra_fields.custodian')}
          fullWidth
          label="Gesellschaft"
          custom_classes={newDesignInputCustomClasses}
        />
      </Grid>
    </>
  )
}